import { COLOR_PALETTE } from 'constants/ui';

// A number's height plus a little air, so stacked numbers never touch.
export const MARK_BADGE_STEP_PX = 24;

export const PERCENT = 100;

// The frame around a changed part sits on the white page in both themes, so it keeps light-page
// colours: the mark pill's border hue, filled lightly.
export const MARK_COLOR = {
  FRAME: COLOR_PALETTE.ORANGE[5],
  FILL: COLOR_PALETTE.ORANGE[4],
};
